import { toFixedNumberAmount, toFixedNumberAmountNew, delcommafy } from '@/common/js/util';
import globalVar from '@/common/js/global';
// import XEUtils from 'xe-utils/methods/xe-utils';
var countDecimals = function (num) {
  var len = 0;
  try {
    num = Number(num);
    var str = num.toString().toUpperCase();
    if (str.split('E').length === 2) {
      // scientific notation
      var isDecimal = false;
      if (str.split('.').length === 2) {
        str = str.split('.')[1];
        if (parseInt(str.split('E')[0]) !== 0) {
          isDecimal = true;
        }
      }
      let x = str.split('E');
      if (isDecimal) {
        len = x[0].length;
      }
      len -= parseInt(x[1]);
    } else if (str.split('.').length === 2) {
      // decimal
      if (parseInt(str.split('.')[1]) !== 0) {
        len = str.split('.')[1].length;
      }
    }
  } finally {
    if (isNaN(len) || len < 0) {
      len = 0;
    }
  }
  return len;
};

var convertToInt = function (num) {
  num = Number(num);
  var newNum = num;
  var times = countDecimals(num);
  var temp_num = num.toString().toUpperCase();
  if (temp_num.split('E').length === 2) {
    newNum = Math.round(num * Math.pow(10, times));
  } else {
    newNum = Number(temp_num.replace('.', ''));
  }
  return newNum;
};

var getCorrectResult = function (type, num1, num2, result) {
  var temp_result = 0;
  switch (type) {
    case 'add':
      temp_result = num1 + num2;
      break;
    case 'sub':
      temp_result = num1 - num2;
      break;
    case 'div':
      temp_result = num1 / num2;
      break;
    case 'mul':
      temp_result = num1 * num2;
      break;
  }
  if (Math.abs(result - temp_result) > 1) {
    return temp_result;
  }
  return result;
};
export default {
  //加法
  accAdd(num1 = 0, num2 = 0) {
    num1 = Number(num1);
    num2 = Number(num2);
    var dec1, dec2, times;
    try {
      dec1 = countDecimals(num1) + 1;
    } catch (e) {
      dec1 = 0;
    }
    try {
      dec2 = countDecimals(num2) + 1;
    } catch (e) {
      dec2 = 0;
    }
    times = Math.pow(10, Math.max(dec1, dec2));
    // var result = (num1 * times + num2 * times) / times;
    var result = (this.accMul(num1, times) + this.accMul(num2, times)) / times;
    return getCorrectResult('add', num1, num2, result);
    // return result;
  },
  //减法
  accSub(num1 = 0, num2 = 0) {
    num1 = Number(num1);
    num2 = Number(num2);
    var dec1, dec2, times;
    try {
      dec1 = countDecimals(num1) + 1;
    } catch (e) {
      dec1 = 0;
    }
    try {
      dec2 = countDecimals(num2) + 1;
    } catch (e) {
      dec2 = 0;
    }
    times = Math.pow(10, Math.max(dec1, dec2));
    // var result = Number(((num1 * times - num2 * times) / times);
    var result = Number((this.accMul(num1, times) - this.accMul(num2, times)) / times);
    return getCorrectResult('sub', num1, num2, result);
    // return result;
  },
  //除法
  accDiv(num1 = 0, num2 = 0) {
    num1 = Number(num1);
    num2 = Number(num2);
    var t1 = 0,
      t2 = 0,
      dec1,
      dec2;
    try {
      t1 = countDecimals(num1);
    } catch (e) {
      console.log(e);
    }
    try {
      t2 = countDecimals(num2);
    } catch (e) {
      console.log(e);
    }
    dec1 = convertToInt(num1);
    dec2 = convertToInt(num2);
    var result = this.accMul(dec1 / dec2, Math.pow(10, t2 - t1));
    return getCorrectResult('div', num1, num2, result);
    // return result;
  },
  //乘法
  accMul(num1 = 0, num2 = 0) {
    num1 = Number(num1);
    num2 = Number(num2);
    var times = 0,
      s1 = num1.toString(),
      s2 = num2.toString();
    try {
      times += countDecimals(s1);
    } catch (e) {
      console.log(e);
    }
    try {
      times += countDecimals(s2);
    } catch (e) {
      console.log(e);
    }
    var result = (convertToInt(s1) * convertToInt(s2)) / Math.pow(10, times);
    return getCorrectResult('mul', num1, num2, result);
    // return result;
  },
  //常用计算公式
  /*
        公共计算公式
        num1,num2,计算值
        method： + - * / 计算符
        pointType： price amount(默认值) quantity 精度类型 其他情况直接传数字
    */
  calCommon(num1 = 0, num2 = 0, method, pointType) {
    num1 = Number(delcommafy(num1));
    num2 = Number(delcommafy(num2));
    method = this.getMethod(method);
    let point = this.getPoint(pointType);
    let msg = [];
    if (num1 == null || num1 == '') num1 = 0;
    if (num2 == null || num2 == '') num2 = 0;
    if (['accAdd', 'accDiv', 'accSub', 'accMul'].indexOf(method) == -1)
      msg.push('method传入值为:' + method);
    if (msg[0]) {
      this.$message({ showClose: true, type: 'info', message: msg.join(',') });
      return;
    }
    let num = '';
    if (method === 'accAdd') {
      num = this.accAdd(num1, num2);
    } else if (method === 'accDiv') {
      num = this.accDiv(num1, num2);
    } else if (method === 'accSub') {
      num = this.accSub(num1, num2);
    } else if (method === 'accMul') {
      num = this.accMul(num1, num2);
    }
    // let num = eval("this."+method+"("+num1+","+num2+")")
    return toFixedNumberAmountNew(num, point);
  },
  //1.单价：金额/数量
  calPrice(amount, quantity) {
    return toFixedNumberAmount(this.accDiv(amount, quantity), globalVar.pPoint);
  },
  //2.数量：金额/单价
  calQuantity(amount, price) {
    return toFixedNumberAmount(this.accDiv(amount, price), globalVar.qPoint);
  },
  //3.金额：单价*数量
  calAmount(price, quantity) {
    return toFixedNumberAmount(this.accMul(quantity, price), globalVar.aPoint);
  },
  //4.加减完需要精确位数的计算
  //5.中间过程计算，不需要存储的直接使用BigDecimal的加减乘除

  //根据入参判断方法名
  getMethod(value) {
    let method = value;
    if (value == '+' || value == 'add') {
      method = 'accAdd';
    } else if (value == '-' || value == 'sub') {
      method = 'accSub';
    } else if (value == '*' || value == 'mul') {
      method = 'accMul';
    } else if (value == '/' || value == 'div') {
      method = 'accDiv';
    }
    return method;
  },
  //根据入参判断精度
  getPoint(value) {
    let point = value;
    if (value == 'price') {
      point = globalVar.pPoint;
    } else if (value == 'amount') {
      point = globalVar.aPoint;
    } else if (value == 'quantity') {
      point = globalVar.qPoint;
    } else if (value == 'exchange') {
      point = globalVar.ePoint;
    } else if (value == 'day') {
      point = globalVar.dPoint;
    } else if (value == 'interest') {
      point = globalVar.iPoint;
    } else if (value == 'tax') {
      point = globalVar.tPoint;
    }
    return point;
  },
};
